var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8956 10.5069C15.8274 10.7481 15.4986 10.7481 15.4304 10.5069C14.853 8.47038 13.2477 6.86995 11.216 6.29015C10.9749 6.22193 10.9749 5.89555 11.216 5.82733C13.2526 5.24753 14.853 3.6446 15.4304 1.61056C15.4986 1.3694 15.8274 1.3694 15.8956 1.61056C16.473 3.6471 18.0783 5.24753 20.1099 5.82733C20.3511 5.89555 20.3511 6.22193 20.1099 6.29015C18.0783 6.86995 16.473 8.47282 15.8956 10.5069Z",
    fill: "#828BEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2375 15.1019C22.7125 15.5355 21.5092 16.7389 21.0755 18.2663C21.0244 18.4466 20.7784 18.4466 20.7296 18.2663C20.296 16.7389 19.0926 15.5355 17.5677 15.1019C17.385 15.0532 17.385 14.8072 17.5677 14.756C19.0926 14.3248 20.296 13.1214 20.7296 11.5941C20.7784 11.4114 21.0244 11.4114 21.0755 11.5941C21.5092 13.1214 22.7125 14.3248 24.2375 14.756C24.4202 14.8072 24.4202 15.0483 24.2375 15.1019Z",
    fill: "#828BEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2363 17.9773C11.1888 18.8445 8.78202 21.2465 7.91722 24.2988C7.81249 24.6618 7.32284 24.6618 7.21811 24.2988C6.35331 21.2489 3.95137 18.8445 0.899052 17.9773C0.533649 17.8726 0.533649 17.3854 0.899052 17.2806C3.94652 16.4158 6.35331 14.0139 7.21811 10.9616C7.32284 10.5961 7.81249 10.5961 7.91722 10.9616C8.78202 14.0091 11.1839 16.4158 14.2363 17.2806C14.6017 17.3854 14.6017 17.8726 14.2363 17.9773Z",
    fill: "#828BEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicStar);
export default __webpack_public_path__ + "static/media/magic_star.e0e510dddad8c09e65538a33903ae8b8.svg";
export { ForwardRef as ReactComponent };